import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface InternalRouteProps {
    children?: React.ReactNode;
}

export const InternalRoute: React.FC<InternalRouteProps> = ({ children }) => {
    const { isInternal } = useAuth();
    const location = useLocation();

    if (!isInternal) {
        return <Navigate to="/access-denied" replace state={{ from: location.pathname }} />;
    }

    return <>{children ?? <Outlet />}</>;
};
